import { useLocalObservable } from 'mobx-react';
import React, { createContext, ReactNode } from 'react';
import { RxApi, TicketsApi } from '../../api-client';
import useStore from '../../helpers/useStore';
import { AuthContext } from '../Auth/auth.provider';
import { createApiConfig } from '../../api/createApiConfig';
import TicketsStore from './ticketsStore';


interface TicketsProviderProps {
  children: ReactNode;
}

export const TicketsStoreContext = createContext<TicketsStore | null>(null);
TicketsStoreContext.displayName = 'TicketsStoreContext';

export const TicketsStoreProvider = ({ children }: TicketsProviderProps) => {
const AuthenticationStore = useStore(AuthContext);
  const apiClient = new TicketsApi(createApiConfig());

  // eslint-disable-next-line react-hooks/rules-of-hooks
  const store = useLocalObservable(
    () => new TicketsStore(apiClient,AuthenticationStore)
  );

  store.apiClient = apiClient;

  return (
    <TicketsStoreContext.Provider value={store}>
      {children}
    </TicketsStoreContext.Provider>
  );
};